import { log } from "../utils";
export default class ChunkHandler {
    constructor(eventEmitter) {
        this.responseDataString = "";
        this.currentChunkIndex = 0;
        this.currentReferenceId = "";
        this.eventEmitter = eventEmitter;
    }
    handleChunkedResponse(chunkedResponse) {
        if (ChunkHandler.isFirstChunk(chunkedResponse.meta)) {
            this.handleFirstChunk(chunkedResponse);
        }
        else if (this.isChunkContinuityBroken(chunkedResponse)) {
            const errorMessage = this.constructBrokenContinuityErrorMessage(chunkedResponse);
            this.emitError(errorMessage);
            return;
        }
        else {
            this.handleResponseChunk(chunkedResponse);
        }
        if (ChunkHandler.isFinalChunk(chunkedResponse.meta)) {
            this.emitResponse(chunkedResponse.meta);
        }
    }
    static isChunkedResponse(response) {
        return !!(response.meta.totalChunks && response.meta.totalChunks >= 1);
    }
    static isFirstChunk(chunkedResponseMeta) {
        return chunkedResponseMeta.chunkIndex === 0;
    }
    static isFinalChunk(chunkedResponseMeta) {
        // index starts counting at 0
        return chunkedResponseMeta.chunkIndex + 1 === chunkedResponseMeta.totalChunks;
    }
    isChunkContinuityBroken(chresponse) {
        return !this.isCorrectChunkIndex(chresponse) || !this.isCorrectReferenceMessageId(chresponse);
    }
    isCorrectChunkIndex(response) {
        return response.meta.chunkIndex === this.currentChunkIndex + 1;
    }
    isCorrectReferenceMessageId(response) {
        return response.meta.referenceMessageId === this.currentReferenceId;
    }
    constructBrokenContinuityErrorMessage(response) {
        if (!this.isCorrectChunkIndex(response)) {
            return (`Expected chunk number '${this.currentChunkIndex}',` +
                `but received chunk number '${response.meta.chunkIndex}'`);
        }
        if (!this.isCorrectReferenceMessageId(response)) {
            return "Received a chunk with a mismatching reference id, aborting";
        }
        return "Error in chunk continuity";
    }
    handleFirstChunk(response) {
        log.debug(`Received first chunk of response with ${response.meta.totalChunks} total chunks`);
        this.currentReferenceId = response.meta.referenceMessageId;
        this.currentChunkIndex = 0;
        this.responseDataString = response.data;
    }
    handleResponseChunk(response) {
        this.currentChunkIndex += 1;
        log.debug(`Received response chunk with index ${this.currentChunkIndex}`);
        this.responseDataString += response.data;
    }
    emitError(errorMessage) {
        log.error(errorMessage);
        this.eventEmitter.emit(this.currentReferenceId, new Error(errorMessage));
    }
    emitResponse(responseMeta) {
        log.debug("Got whole chunked response");
        let data;
        try {
            // Remove wrongly added line breaks, see https://collaboration.msi.audi.com/jira/browse/AVE-5365
            data = JSON.parse(this.responseDataString.replace(/[\n\r]/g, ""));
        }
        catch (error) {
            const errorMessage = "Failed parsing the chunked response";
            this.emitError(errorMessage);
            return;
        }
        const response = {
            meta: responseMeta,
            data,
        };
        this.eventEmitter.emit(this.currentReferenceId, response);
    }
}
//# sourceMappingURL=chunk-handler.js.map